import React from "react";
import { Dropdown } from "react-bootstrap";
import cx from "classnames";

import { FilterOption } from "../../types";
import styles from "./filterDropdown.module.scss";

interface FilterDropdownProps {
  options: FilterOption[];
  selected: FilterOption;
  onSelect: (option: FilterOption) => void;
}

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
  options,
  selected,
  onSelect,
}) => {
  const hasActiveFilter = selected.value !== null;

  return (
    <Dropdown className={styles.dropdownWrapper}>
      <Dropdown.Toggle
        as="div"
        className={cx(styles.dropDown, { [styles.active]: hasActiveFilter })}
      >
        {selected.label}
        <i className="paperflite-dropdown" />
      </Dropdown.Toggle>

      <Dropdown.Menu
        popperConfig={{
          modifiers: [{ name: "offset", options: { offset: [0, 6] } }],
        }}
      >
        {options.map((option) => (
          <Dropdown.Item
            key={option.value ?? "all"}
            active={option.value === selected.value}
            onClick={() => onSelect(option)}
          >
            <span>{option.label}</span>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
